"use client";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsSankey from "highcharts/modules/sankey";
HighchartsSankey(Highcharts);

function SankeyChart({ data, from }) {
  const options = {
    chart: {
      type: "sankey",
    },
    series: [
      {
        keys: ["from", "to", "weight"],
        data: Object.entries(data).map(([label, value]) => [
          from,
          label,
          value,
        ]),

        type: "sankey",
      },
    ],
    title: {
      text: "",
    },
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
export default SankeyChart;
